// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__P8-Fy","itemTitle":"ClientEmergencyInfo_itemTitle__3zfU7","itemText":"ClientEmergencyInfo_itemText__LJCHf"};